import React from "react";
import { Cookies } from "./Cookies";
import { Cost } from "./Cost";
import { GradeInfo } from "./GradeInfo";
import { Legal } from "./Legal";
import { Privacity } from "./Privacity";
import { What } from "./What";
import { When } from "./When";



export const Info = () => {

    const renderPage = () => {
        const page = window.location.pathname;
        const component = getTitle(page.substring(1, page.length))
        return (
            <>
                {component.component}
            </>
        );
    }

    const getTitle = page => {
        switch (page) {
            case "privacity":
                return {
                    component: <Privacity />
                }
            case "legal":
                return {
                    component: <Legal />
                }
            case "cookies":
                return {
                    component: <Cookies />
                }
            case "info":
                return {
                    title: "Cómo funciona eGrade",
                    component: <GradeInfo />
                }
            case "what":
                return {
                    title: "Qué es el eGrade",
                    component: <What />
                }
            case "Cost":
                return {
                    title: "Tarifa de eGrade",
                    component: <Cost />
                }
            case "When":
                return {
                    title: "Cuándo usar eGrade",
                    component: <When />
                }
            default:
                return {
                    title: '',
                    component: null
                }
        }
    }

    return (
        <div className="info">
            {renderPage()}
        </div>
    );

}